import { useEffect } from "react";
import Box from "../../components/Box";
import { useNavigate } from "react-router";
import { useRange } from "../../context/rangeContext";
import { useOptionCommercial } from "../../utils/options";
import { isStoreOpen } from "../../utils/storeUtils";
import { useStores } from "../../context/storesContext";
import { Range } from "../../utils/range";

function Default() {
  const navigate = useNavigate();
  const { getKpiRange } = useRange();
  const optionsCommercial = useOptionCommercial();
  const { selectedStore } = useStores();

  useEffect(() => {
    const range = getKpiRange("kpi_commercial");
    const open = isStoreOpen(selectedStore?.openingTime, selectedStore?.closingTime);
    const savedOption = optionsCommercial.find((opt: any) => opt.range === range);

    // Live et yesterday sont toujours déterminés par l'état du magasin
    const isLive = savedOption?.range === Range.Direct;
    const resolvedOption = isLive ? undefined : savedOption;
    const livePath = optionsCommercial.find((opt: any) => opt.range === Range.Direct);
    const path = resolvedOption?.value ?? (open && livePath  ? livePath.value : optionsCommercial[0]?.value);

    navigate(path);
  }, [navigate, getKpiRange, optionsCommercial, selectedStore?.openingTime, selectedStore?.closingTime]);
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent={["space-between", "flex-start"]}
      flex="1"
    ></Box>
  );
}

export default Default;
